<template lang="html">
<div class="sidebar-sparkline" v-if="datasets">
    <canvas class="chart" :id="id" :height="height" :width="width"></canvas>
    <div class="hover-cta">
        <v-btn @click="$emit('click')">View more...</v-btn>
    </div>
</div>
</template>

<script>
import Chart from 'chart.js';

export default {
    name: 'sidebar-sparkline',
    props: {
        datasets: {
            required: true,
        },
        options: {
            type: Object,
        },
        labels: {
            type: Promise,
        },
        id: {
            required: true,
            type: String,
        },
        height: {
            type: [Number, String],
            default: 100,
        },
        width: {
            type: [Number, String],
            default: 300,
        },
    },
    data() {
        return {
            chart: null,
            defaultDataset: {
                borderColor: '#ff0000',
                borderWidth: 2,
                pointRadius: 0,
                fill: false,
            },
            defaultOptions: {
                legend: {
                    display: false,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            display: false,
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            display: false,
                        },
                    }],
                },
                animation: {
                    duration: 0,
                },
                tooltips: {
                    enabled: false,
                },
            },
        };
    },
    beforeDestroy() {
        this.chart.destroy();
    },
    computed: {
        // allow custom labels
        async scaleLabels() {
            if (await this.labels) {
                return this.labels;
            }
            // blank labels matching the length of the input data
            return (await this.datasets)[0].data.map(() => '');
        },
    },
    mounted() {
        this.renderChart();
    },
    updated() {
        // re-render charts when data changes
        this.renderChart();
    },
    methods: {
        async renderChart() {
            const data = await this.datasets;
            // only render if the data is ready
            if (!data || this.chart !== null) {
                return;
            }

            // sparkline doesn't show labels, but they're needed for chart.js scaling
            const labels = await this.scaleLabels;
            // merge datasets with default options
            const datasets = data.map((d) => {
                const merged = Object.assign({}, this.defaultDataset, d);
                return merged;
            });
            // merge with default options
            const options = Object.assign({}, this.defaultOptions, this.options);
            this.chart = new Chart(this.id, { // eslint-disable-line
                type: 'line',
                data: {
                    labels,
                    datasets,
                },
                options,
            });
        },
    },
};
</script>

<style lang="scss">
.sidebar-sparkline {
    position: relative;

    &:hover {
        .hover-cta {
            opacity: 1;
        }
    }

    .hover-cta {
        transition: opacity .25s;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(25, 25, 25, .5);
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarSparkline.vue